var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/system';
import { useEffect, useState } from 'react';
import Digit from './Digit';
import { motion, useAnimation } from 'framer-motion';
var Input = styled('div')({
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 2rem))',
    gap: '1rem',
});
export function TripletInput(_a) {
    var value = _a.value, isShaking = _a.isShaking, _b = _a.digitStyle, digitStyle = _b === void 0 ? {} : _b, className = _a.className, _c = _a.keepInactiveBorder, keepInactiveBorder = _c === void 0 ? false : _c;
    var _d = useState([]), _value = _d[0], _setValue = _d[1];
    useEffect(function () {
        if (!value || value.length >= 4)
            return;
        _setValue(value);
    }, [value]);
    var controls = useAnimation();
    useEffect(function () {
        if (isShaking)
            controls.start('start');
        else {
            controls.stop();
            controls.set('reset');
        }
    }, [isShaking, controls]);
    var variants = {
        start: {
            x: [-7, 5, 0],
            transition: {
                repeat: 1,
                duration: 0.2,
            },
        },
        reset: {
            x: 0,
        },
    };
    return (_jsx(motion.div, __assign({ variants: variants, animate: controls }, { children: _jsxs(Input, __assign({ className: className }, { children: [_jsx(Digit, { value: _value[0], extraStyles: digitStyle, activeIndex: value === null || value === void 0 ? void 0 : value.length, index: 0, keepInactiveBorder: keepInactiveBorder }), _jsx(Digit, { value: _value[1], extraStyles: digitStyle, activeIndex: value === null || value === void 0 ? void 0 : value.length, index: 1, keepInactiveBorder: keepInactiveBorder }), _jsx(Digit, { value: _value[2], extraStyles: digitStyle, activeIndex: value === null || value === void 0 ? void 0 : value.length, index: 2, keepInactiveBorder: keepInactiveBorder })] })) })));
}
export default TripletInput;
